import comp from "./UnitCard";
export default comp;
